import styled from "styled-components";
import { windowWidth } from "@styles/global";
import { shade } from "polished";

const FormEnvIconsContainer = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  @media (max-width: ${windowWidth.tablet}) {
    width: 100%;
  }
`;

const ParamItem = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 2rem;
  }
  
  .MuiTextField-root.numberInput {
    width: 3rem;
    
    input {
      text-align: center;
    }
  }
`;

const ParamItemText = styled.div`
  font-size: 0.875rem;
  color: rgba(0,0,0, 0.6);
  width: 50%;

  @media (max-width: ${windowWidth.tablet}) {
    width: 75%;
  }
`;

const SubmitContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const SubmitButton = styled.button`
  padding: 12px 8px;
  cursor: pointer;
  border-radius: 10px;
  color: ${({ theme }) => theme.colors.primary};
  background-color: #fff;
  border: 3px solid ${({ theme }) => theme.colors.primary};
  max-width: 7rem;
  margin-left: auto;
  margin-right: 8px;
  font-weight: 600;

  &:hover:enabled {
    background-color: ${() => shade(0.2, "#e0e0eb")};
  }

  @media (max-width: ${windowWidth.tablet}) {
    transform: scale(1);
  }
`;

const ReloadSubmitInfoSpan = styled.span`
    margin-left: auto;
    margin-right: 8px;
    color: red;
    font-size: 0.875rem;
`;

export default {
  FormEnvIconsContainer,
  ParamItem,
  ParamItemText,
  SubmitContainer,
  SubmitButton,
  ReloadSubmitInfoSpan
};